export function minutesByRate(quantity?: number, rate?: number): number {
  if (!quantity || !rate) return 0;
  return Math.ceil(quantity / rate);
}
